import { render, staticRenderFns } from "./Discussion.vue?vue&type=template&id=191f6e85"
import script from "./Discussion.vue?vue&type=script&lang=js"
export * from "./Discussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('191f6e85')) {
      api.createRecord('191f6e85', component.options)
    } else {
      api.reload('191f6e85', component.options)
    }
    module.hot.accept("./Discussion.vue?vue&type=template&id=191f6e85", function () {
      api.rerender('191f6e85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/Discussion.vue"
export default component.exports